import { ReactElement } from 'react';
import { NEW_NON_EMPLOYEE_KEYS } from 'pages/NewNonEmployee/_const';
import CustomRadioGroup from '../base/CustomRadioGroup';

/**
 * Prompt user for input: site admin
 * @param {string|ReactElement} labelUsernameType label of the user type (defaults to 'user')
 * @returns {ReactElement} ask user to indicate if new user is a site admin
 */
const SiteAdminCheck = ({ labelUsernameType = 'user' }) => {
	return (
		<CustomRadioGroup
			id={'site-admin-check'}
			label={
				'Is the new ' +
				labelUsernameType +
				' you are provisioning going to act as the site administrator?'
			}
			options={[
				{ key: 'Yes', label: 'Yes', value: true },
				{ key: 'No', label: 'No', value: false },
			]}
			name={NEW_NON_EMPLOYEE_KEYS.IS_SITE_ADMIN}
			required
			row
		/>
	);
};
export default SiteAdminCheck;
